<template>
<main class="PcQr-MAIN DISPLAY">

    <div>
        <img src="../assets/pc-qr.png"/>
        <p>Escanea para abrir en tu teléfono</p>
    </div>

    <div>
        <p>Te avisaremos cuando la versión de escritorio esté lista</p>
        <p>Email:</p>
        <input type="email" placeholder="correo@ejemplo.com" v-model="form.email"/>
        <label>
            <input type="checkbox" v-model="form.acceptedPolicy"/>
            <p>Comprendo y acepto la &nbsp;<a href="">[Política de privacidad]</a>.</p>
        </label>
        <button :disabled="!form.acceptedPolicy">Quiero el aviso</button>
    </div>

</main>
</template>

<script>
export default {
    name: 'PcQr-MAIN',
    data(){
        return{
            form: {
                email: '',
                name: 'pc',
                acceptedPolicy: false,
            }
        }
    }
}
</script>

<style scoped lang="stylus">
.PcQr-MAIN
    flex-direction: row
    align-items: center
    justify-content: center

    >div
        display: flex
        flex-direction: column
        color: white   
        text-transform: uppercase

        &:first-child
            font-family: "Archivo ExtraCondensed", sans-serif
            align-items: center
            width: 200px
            margin-right: 120px

            img
                width: 100%

            p
                font-size: 4.3ch
                text-align: center
                text-wrap: pretty
                margin-bottom: 0

        &:last-child
            font-family: "DM Mono", monospace
            width: 450px

            p
                font-weight: 100

            >p:nth-child(1)
                font-size: 2.4ch
                margin: 0
                margin-bottom: 20px

            input
                color: white
                padding: 5px
                border: none
                border-bottom: 1px solid white
                background-color: transparent
                font-family: "DM Mono", monospace

            label
                display: flex
                align-items: center
                margin-top: 25px
                margin-bottom: 20px
                font-size: 1.2ch
                font-family: "Archivo ExtraCondensed", sans-serif

                >input
                    margin-right: 10px

                a
                    color: gray

            button
                font-family: "DM Mono", monospace
                color: white
                border: none
                border-radius: 100vw
                background-color: rgb(1, 90, 255)
                padding: 10px 10px
                text-transform: uppercase
                
</style>